// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.welcome-overlay {
  position: fixed;
  inset: 0;
  z-index: 10010;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background:
    radial-gradient(circle at top, rgba(239, 68, 68, 0.18), transparent 32%),
    rgba(0, 0, 0, 0.92);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
}

.welcome-modal {
  position: relative;
  container-name: welcome-modal;
  container-type: inline-size;
  width: min(100%, 440px);
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  background:
    linear-gradient(180deg, rgba(22, 22, 26, 0.98) 0%, rgba(10, 10, 10, 0.98) 100%);
  box-shadow:
    0 28px 90px rgba(0, 0, 0, 0.65),
    inset 0 1px 0 rgba(255, 255, 255, 0.05);
  animation: welcome-modal-in 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

.welcome-accent {
  height: 2px;
  background: linear-gradient(90deg, rgba(239, 68, 68, 0), #ef4444, rgba(239, 68, 68, 0));
}

.welcome-panels {
  overflow: hidden;
}

.welcome-panels-track {
  display: flex;
  transition: transform 250ms ease;
}

.welcome-panel {
  flex: 0 0 100%;
  padding: 32px 28px 24px;
  text-align: center;
}

.welcome-mark {
  position: relative;
  width: 72px;
  height: 72px;
  margin: 0 auto 22px;
  display: grid;
  place-items: center;
}

.welcome-mark-ring {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(239, 68, 68, 0.18), rgba(239, 68, 68, 0.02));
  border: 1px solid rgba(239, 68, 68, 0.22);
  box-shadow: 0 0 24px rgba(239, 68, 68, 0.12);
}

.welcome-mark-icon {
  position: relative;
  width: 28px;
  height: 28px;
  object-fit: contain;
}

.welcome-eyebrow {
  display: inline-block;
  margin-bottom: 10px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.22em;
  color: rgba(239, 68, 68, 0.82);
}

.welcome-title {
  margin: 0 0 12px;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.15;
  color: #f5f5f5;
}

.welcome-body {
  margin: 0;
  font-size: 13px;
  line-height: 1.65;
  color: rgba(255, 255, 255, 0.5);
}

.welcome-arsenal {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-top: 20px;
}

.welcome-arsenal-block {
  padding: 14px 10px 12px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.03);
}

.welcome-arsenal-icon {
  width: 32px;
  height: 32px;
  margin: 0 auto 10px;
  display: grid;
  place-items: center;
  border-radius: 10px;
  background: rgba(239, 68, 68, 0.08);
  border: 1px solid rgba(239, 68, 68, 0.16);
  color: #ef4444;
}

.welcome-arsenal-icon svg {
  width: 18px;
  height: 18px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.welcome-arsenal-label {
  margin-bottom: 6px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #f5f5f5;
}

.welcome-arsenal-body {
  font-size: 11px;
  line-height: 1.45;
  color: rgba(255, 255, 255, 0.46);
}

.welcome-footer {
  padding: 0 28px 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
}

.welcome-dots {
  display: flex;
  align-items: center;
  gap: 8px;
}

.welcome-dot {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.12);
  transition: all 200ms ease;
}

.welcome-dot--active {
  width: 18px;
  background: #ef4444;
}

.welcome-btn {
  min-width: 132px;
  border: none;
  border-radius: 10px;
  padding: 11px 28px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  box-shadow: 0 10px 26px rgba(239, 68, 68, 0.22);
  cursor: pointer;
  transition: transform 150ms ease, filter 150ms ease, box-shadow 150ms ease;
}

.welcome-btn:hover {
  transform: translateY(-1px);
  filter: brightness(1.06);
  box-shadow: 0 14px 32px rgba(239, 68, 68, 0.28);
}

.welcome-btn:active {
  transform: translateY(0);
}

@keyframes welcome-modal-in {
  from {
    opacity: 0;
    transform: scale(0.92);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@media (max-width: 1800px) {
  .welcome-modal {
    width: min(100%, clamp(400px, 30vw, 440px));
  }

  .welcome-panel {
    padding:
      clamp(28px, 1.78vw, 32px)
      clamp(22px, 1.56vw, 28px)
      clamp(20px, 1.33vw, 24px);
  }

  .welcome-mark {
    width: clamp(60px, 4vw, 72px);
    height: clamp(60px, 4vw, 72px);
    margin-bottom: clamp(18px, 1.22vw, 22px);
  }

  .welcome-mark-icon {
    width: clamp(24px, 1.56vw, 28px);
    height: clamp(24px, 1.56vw, 28px);
  }

  .welcome-title {
    font-size: clamp(21px, 1.33vw, 24px);
  }

  .welcome-arsenal {
    gap: clamp(10px, 0.67vw, 12px);
  }

  .welcome-footer {
    padding:
      0
      clamp(22px, 1.56vw, 28px)
      clamp(20px, 1.56vw, 28px);
  }
}

@container welcome-modal (max-width: 432px) {
  .welcome-arsenal {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 520px) {
  .welcome-overlay {
    padding: 16px;
  }

  .welcome-panel {
    padding: 28px 20px 20px;
  }

  .welcome-footer {
    padding: 0 20px 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/WelcomeModal/WelcomeModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb;;uBAEqB;EACrB,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,2BAA2B;EAC3B,uBAAuB;EACvB,gBAAgB;EAChB,2CAA2C;EAC3C,mBAAmB;EACnB;mFACiF;EACjF;;2CAEyC;EACzC,8DAA8D;AAChE;;AAEA;EACE,WAAW;EACX,uFAAuF;AACzF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,qFAAqF;EACrF,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,6DAA6D;EAC7D,+CAA+C;EAC/C,eAAe;EACf,0EAA0E;AAC5E;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,2CAA2C;EAC7C;;EAEA;IACE;;;+BAG2B;EAC7B;;EAEA;IACE,6BAA6B;IAC7B,8BAA8B;IAC9B,wCAAwC;EAC1C;;EAEA;IACE,gCAAgC;IAChC,iCAAiC;EACnC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE;;;+BAG2B;EAC7B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;EACtB;AACF","sourcesContent":[".welcome-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 10010;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background:\n    radial-gradient(circle at top, rgba(239, 68, 68, 0.18), transparent 32%),\n    rgba(0, 0, 0, 0.92);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n}\n\n.welcome-modal {\n  position: relative;\n  container-name: welcome-modal;\n  container-type: inline-size;\n  width: min(100%, 440px);\n  overflow: hidden;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 16px;\n  background:\n    linear-gradient(180deg, rgba(22, 22, 26, 0.98) 0%, rgba(10, 10, 10, 0.98) 100%);\n  box-shadow:\n    0 28px 90px rgba(0, 0, 0, 0.65),\n    inset 0 1px 0 rgba(255, 255, 255, 0.05);\n  animation: welcome-modal-in 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.welcome-accent {\n  height: 2px;\n  background: linear-gradient(90deg, rgba(239, 68, 68, 0), #ef4444, rgba(239, 68, 68, 0));\n}\n\n.welcome-panels {\n  overflow: hidden;\n}\n\n.welcome-panels-track {\n  display: flex;\n  transition: transform 250ms ease;\n}\n\n.welcome-panel {\n  flex: 0 0 100%;\n  padding: 32px 28px 24px;\n  text-align: center;\n}\n\n.welcome-mark {\n  position: relative;\n  width: 72px;\n  height: 72px;\n  margin: 0 auto 22px;\n  display: grid;\n  place-items: center;\n}\n\n.welcome-mark-ring {\n  position: absolute;\n  inset: 0;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(239, 68, 68, 0.18), rgba(239, 68, 68, 0.02));\n  border: 1px solid rgba(239, 68, 68, 0.22);\n  box-shadow: 0 0 24px rgba(239, 68, 68, 0.12);\n}\n\n.welcome-mark-icon {\n  position: relative;\n  width: 28px;\n  height: 28px;\n  object-fit: contain;\n}\n\n.welcome-eyebrow {\n  display: inline-block;\n  margin-bottom: 10px;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.22em;\n  color: rgba(239, 68, 68, 0.82);\n}\n\n.welcome-title {\n  margin: 0 0 12px;\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 1.15;\n  color: #f5f5f5;\n}\n\n.welcome-body {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.65;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.welcome-arsenal {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n  margin-top: 20px;\n}\n\n.welcome-arsenal-block {\n  padding: 14px 10px 12px;\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.03);\n}\n\n.welcome-arsenal-icon {\n  width: 32px;\n  height: 32px;\n  margin: 0 auto 10px;\n  display: grid;\n  place-items: center;\n  border-radius: 10px;\n  background: rgba(239, 68, 68, 0.08);\n  border: 1px solid rgba(239, 68, 68, 0.16);\n  color: #ef4444;\n}\n\n.welcome-arsenal-icon svg {\n  width: 18px;\n  height: 18px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 2;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.welcome-arsenal-label {\n  margin-bottom: 6px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #f5f5f5;\n}\n\n.welcome-arsenal-body {\n  font-size: 11px;\n  line-height: 1.45;\n  color: rgba(255, 255, 255, 0.46);\n}\n\n.welcome-footer {\n  padding: 0 28px 28px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 18px;\n}\n\n.welcome-dots {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.welcome-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.12);\n  transition: all 200ms ease;\n}\n\n.welcome-dot--active {\n  width: 18px;\n  background: #ef4444;\n}\n\n.welcome-btn {\n  min-width: 132px;\n  border: none;\n  border-radius: 10px;\n  padding: 11px 28px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #fff;\n  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);\n  box-shadow: 0 10px 26px rgba(239, 68, 68, 0.22);\n  cursor: pointer;\n  transition: transform 150ms ease, filter 150ms ease, box-shadow 150ms ease;\n}\n\n.welcome-btn:hover {\n  transform: translateY(-1px);\n  filter: brightness(1.06);\n  box-shadow: 0 14px 32px rgba(239, 68, 68, 0.28);\n}\n\n.welcome-btn:active {\n  transform: translateY(0);\n}\n\n@keyframes welcome-modal-in {\n  from {\n    opacity: 0;\n    transform: scale(0.92);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@media (max-width: 1800px) {\n  .welcome-modal {\n    width: min(100%, clamp(400px, 30vw, 440px));\n  }\n\n  .welcome-panel {\n    padding:\n      clamp(28px, 1.78vw, 32px)\n      clamp(22px, 1.56vw, 28px)\n      clamp(20px, 1.33vw, 24px);\n  }\n\n  .welcome-mark {\n    width: clamp(60px, 4vw, 72px);\n    height: clamp(60px, 4vw, 72px);\n    margin-bottom: clamp(18px, 1.22vw, 22px);\n  }\n\n  .welcome-mark-icon {\n    width: clamp(24px, 1.56vw, 28px);\n    height: clamp(24px, 1.56vw, 28px);\n  }\n\n  .welcome-title {\n    font-size: clamp(21px, 1.33vw, 24px);\n  }\n\n  .welcome-arsenal {\n    gap: clamp(10px, 0.67vw, 12px);\n  }\n\n  .welcome-footer {\n    padding:\n      0\n      clamp(22px, 1.56vw, 28px)\n      clamp(20px, 1.56vw, 28px);\n  }\n}\n\n@container welcome-modal (max-width: 432px) {\n  .welcome-arsenal {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 520px) {\n  .welcome-overlay {\n    padding: 16px;\n  }\n\n  .welcome-panel {\n    padding: 28px 20px 20px;\n  }\n\n  .welcome-footer {\n    padding: 0 20px 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
